// extracted by mini-css-extract-plugin
export default {"hoverable":"_274P7u9u","bubbleRatingFilter":"kW7HbB23","poiReviewRating":"tl4jgn9w"};